import moment from 'moment';
import { Interval } from '../../../models/Interval/Interval.js';

class ServiceAvailableDateMapper {
  static createFromResponse(response) {
    const responseDate = Object.keys(response)[0];
    const responseInterval = Object.values(response)[0];
    let serviceIntervals;
    if (responseInterval) {
      const serviceIntervalsData = responseInterval.match(/\[(.*?)\]/g);
      if (serviceIntervalsData) {
        serviceIntervals = serviceIntervalsData.map(serviceInterval => Interval.createFromResponse(serviceInterval)).filter(serInterval => !!serInterval);
      }
    }
    return {
      date: responseDate ? moment(responseDate, 'YYYY/MM/DD').hour(12) : undefined,
      intervals: serviceIntervals
    };
  }
  static getSortedAvailableDates(response) {
    return Object.keys(response).map(date => ServiceAvailableDateMapper.createFromResponse({
      [date]: response[date]
    })).sort((a, b) => a.date.valueOf() - b.date.valueOf());
  }
}

export { ServiceAvailableDateMapper };
//# sourceMappingURL=ServiceAvailableDateMapper.js.map
